import { FC, useContext } from 'react';
import styled, { css } from 'styled-components';

import { GlobalContext } from '@/pages/_app';

const PhoneSlider: FC<any> = ({ activeSlide, phoneRef }) => {
	const { lang } = useContext(GlobalContext);

	const cbSlidesPath = (img) => `/images/chatbots/phone-slides/${lang}/${img}`;

	return (
		<PhoneWrapper>
			<Bar />

			<PhoneFrame ref={phoneRef}>
				<PhoneSliderWrapper>
					<PhoneSlide id="0" $active={activeSlide === 0}>
						<SlideImage src="/images/chatbots/phone-slides/logo.png" />
					</PhoneSlide>

					<PhoneSlide id="10" $active={activeSlide === 1}>
						<SlideImage src={cbSlidesPath('1.png')} />
					</PhoneSlide>

					<PhoneSlide id="11" $active={activeSlide === 2}>
						<SlideImage src={cbSlidesPath('2.png')} />
					</PhoneSlide>

					<PhoneSlide id="12" $active={activeSlide === 3}>
						<SlideImage src={cbSlidesPath('3.png')} />
					</PhoneSlide>

					<PhoneSlide id="13" $active={activeSlide === 4}>
						<SlideImage src={cbSlidesPath('4.png')} />
					</PhoneSlide>

					<PhoneSlide id="14" $active={activeSlide === 5}>
						<SlideImage src={cbSlidesPath('5.png')} />
					</PhoneSlide>

					<PhoneSlide id="15" $active={activeSlide === 6}>
						<SlideImage src={cbSlidesPath('6.png')} />
					</PhoneSlide>

					<PhoneSlide id="16" $active={activeSlide === 7}>
						<SlideImage src={cbSlidesPath('7.png')} />
					</PhoneSlide>

					<PhoneSlide id="17" $active={activeSlide === 8}>
						<SlideImage src={cbSlidesPath('8.png')} />
					</PhoneSlide>
				</PhoneSliderWrapper>
			</PhoneFrame>
		</PhoneWrapper>
	);
};

const PhoneWrapper = styled.div`
	height: 100%;
`;

const PhoneFrame = styled.div`
	position: sticky;
	top: 100px;
	width: 300px;
	height: 567px;

	@media (max-width: 1240px) {
		width: 200px;
	}

	@media (max-width: 799px) {
		width: 130px;
		height: 244px;
		position: relative;
		top: 0;
	}

	&:before {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: var(--color-blue);
		opacity: 0.3;
		filter: blur(80px);
		border-radius: 12px;

		@media (max-width: 799px) {
			display: none;
		}
	}

	&:after {
		content: '';
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background: url(/images/chatbots/phone-mock.png) no-repeat center/contain;
	}
`;

const Bar = styled.hr`
	width: 2px;
	height: calc(100% - 585px);
	border: none;
	background-color: var(--color-white);
	position: absolute;
	top: 284px;
	left: 0;
	right: 0;
	margin: 0 auto;
	overflow: visible;

	&:before,
	&:after {
		content: '';
		display: block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		position: absolute;
		top: 0;
		left: -4px;
		background-color: var(--color-purple);
	}

	&:after {
		top: auto;
		bottom: 0;
	}

	@media (max-width: 799px) {
		display: none;
	}
`;

const PhoneSliderWrapper = styled.div`
	position: absolute;
	width: 243px;
	height: 488px;
	z-index: 1;
	top: 40px;
	left: 32px;

	@media (max-width: 1240px) {
		width: 162px;
		height: 352px;
		top: 106px;
		left: 21px;
	}

	@media (max-width: 799px) {
		top: 15px;
		left: 14px;
		width: 105px;
		height: 220px;
	}
`;

const SlideImage = styled.img<{ $delay?: number }>`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	max-width: 95%;
	max-height: 100%;
	opacity: 0;
	transform: translateY(10px);
	transition-property: all;
	transition-duration: 0.4s;
	transition-timing-function: ease-in-out;

	${({ $delay }) =>
		$delay &&
		css`
			transition-delay: {$delay}s;
		`}
`;

const PhoneSlide = styled.div<{ $active: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;

	${({ $active }) =>
		$active &&
		css`
			${SlideImage} {
				opacity: 1;
				transform: translateY(0);
			}
		`}
`;

export default PhoneSlider;
